import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PartnerRequestService } from '../../../shared/API-Service/services/partner-request.service';
import Swal from 'sweetalert2';
import {BaseComponent } from '../../../../app/shared/components/base/base.component'

@Component({
  selector: 'app-partner-request',
  templateUrl: './partner-request.component.html',
  styleUrls: ['./partner-request.component.css']
})
export class PartnerRequestComponent extends BaseComponent implements OnInit {
  PartnersRequests: any;


  constructor(private PartnerRequestService:PartnerRequestService,private _Router:Router) { super()}
  ngOnInit(): void {
    this.getPartnerRequests();
    
  }
  pageChanged(event: any){
    this.pageNumber = event.page;// -1 * pageSize;
    this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
    this.getPartnerRequests()}
  getPartnerRequests(){
 
    this.PartnerRequestService.GetPartnerRequestsPaged(this.pager).subscribe((res) => {
      this.PartnersRequests = res.data.items
      this.totalCount=res.data.totalCount;
    console.log(this.PartnersRequests);
    
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }
  // update(id){
  //   console.log(id);
  //   //this.PartnersService.Data.next(data);
  //   // this._Router.navigate(['/content/admin/insert-partner']);
  //   this._Router.navigate(['/content/admin/update-partner',id]);
  //   }

    // delete(id : number){
    //   Swal.fire({
    //     title: 'هل تريد مسح العنصر ؟',
    //     text: "لن يكون لك صلاحية إعادته مره اخرى",
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     cancelButtonText: 'الغاء',
    //     confirmButtonText: 'امسح العنصر !'
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       this.PartnersService.DeletePartner(id).subscribe((res) => {
    //         Swal.fire({
    //           icon: "success",
    //           title: "تم المسح بنجاح",
    //           showConfirmButton: false,
    //           timer: 1500,
    //         });
    //      this.getPartners();
    //       },(err) => {
    //         Swal.fire({
    //           icon: 'error',
    //           title: 'خطأ',
    //           text:err.error.message    
    //         })
    //       },() => {
    //         console.log("completed");
    //       })
    //     }
    //   }) 
    // }


}
